import { DOCUMENT, isPlatformBrowser, Location } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, PLATFORM_ID } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { faBars, faPowerOff, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';
import { TutorService } from '../shared/services/tutor/tutor.service';
import { MessagesService } from './../shared/services/messages/message.service';
import { Formulario } from './interface/fomulario';
import { Direccion } from './tiposFormulario/direccion';
import { Email } from './tiposFormulario/email';
import { Movil } from './tiposFormulario/movil';
import { Telefono } from './tiposFormulario/telefono';
import { EstudianteService } from '../shared/services/estudiante/estudiante.service';
import { CursosService } from '../shared/services/cursos/cursos.service';
import * as moment from 'moment';

declare var html2pdf: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {

  public user;
  public userAuth;
  public direccion = new Direccion();
  public email = new Email();
  public telefono = new Telefono();
  public movil = new Movil();
  public menuItemChoosen = 'profile';
  public students = [];
  public projects = [];
  public currentMonth;
  public months = {
    0: 'Enero', 1: 'Febrero', 2: 'Marzo', 3: 'Abril', 4: 'Mayo', 5: 'Junio', 6: 'Julio', 7: 'Agosto',
    8: 'Septiembre', 9: 'Octubre', 10: 'Noviembre', 11: 'Diciembre'
  };
  public cargando = false;
  public arrEvaluationRange = { ene: 0, feb: 1, mar: 2, abr: 3, may: 4, jun: 5, jul: 6, ago: 7, sep: 8, oct: 9, nov: 10, dic: 11 };
  public projectWinner = {};
  public verticalBarOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    showGridLines: true,
    barPadding: 15,
    showXAxisLabel: false,
    xAxisLabel: 'lalalala',
    showYAxisLabel: false,
    yAxisLabel: '',
  };
  public showPdf = true;
  public studentCurrent = 0;
  public countriesData: { name: string; value: number; }[];
  public colorScheme = {
    domain: ['#f15251', '#a8c240', '#34bfbc', '#7c8e9e', '#324ca1']
  };
  public isBrowser: boolean;
  public evaluationsToShow = {};
  public periodEvaluation: any;
  public horarioSelected: string;
  public day: any;
  public fullName: any;
  public municipality: any;
  public address: string;
  public dniDocument: string;
  public nombreCentro: any;
  public mesInscripcion: string;
  public meses: number;
  public objectShow = { autRecogida: true, autImagenes: true, autWhatsapp: true };
  public documentsPDF = { imagenes: 'autImagenes', recogidaMenores: 'autRecogida', whatsapp: 'autWhatsapp' };
  public showPdfContrato = true;
  public showPdfAutorizacionRecogida = true;
  public showPdfAutImagenes = true;
  public showPdfAutWhatsapp = true;
  public showFirma = true;
  public arrMeses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto',
    'septiembre', 'octubre', 'noviembre', 'diciembre'];
  public currentDate = new Date();
  public dataSent: any;
  public recibo: any;
  public dataSourcePDF: any;
  public metodosPago: any;
  public htmlMenores: HTMLElement;
  public htmlMWhatsapp: HTMLElement;
  public htmlImagenes: HTMLElement;
  public htmlSignature: HTMLElement;
  public courseCurrent;
  public documentAuth = {};
  public infoRecogida = {};
  readonly powerOffIcon = faPowerOff;
  readonly menuIcon = faBars;
  readonly menuOpen = faTimes;
  readonly userIcon = faUser;
  // public pdfGenerated: any = this.sanitize.bypassSecurityTrustUrl('');

  constructor(public firebaseAuth: FirebaseAuthComponent,
              private cursosService: CursosService,
              private router: Router,
              private firestore: AngularFirestore,
              private messageService: MessagesService,
              private estudianteService : EstudianteService,
              private ngZone: NgZone,
              private location: Location,
              private tutorService: TutorService,
              @Inject(PLATFORM_ID) private platformId: object,
              @Inject(DOCUMENT) private document: Document,
              private cdRef: ChangeDetectorRef,
              private angularStorage: AngularFireStorage) {

    this.isBrowser = isPlatformBrowser(platformId);
    console.log('el browser es ', this.isBrowser);
    this.countriesData =
      [
        {
          name: 'A',
          value: 2
        },
        {
          name: 'B',
          value: 3
        },
        {
          name: 'C',
          value: 4
        },
        {
          name: 'D',
          value: 4
        },
        {
          name: 'E',
          value: 3
        }
      ];
  }

  ngOnInit(): void {
    const url = this.location.path().replace(';from=login', '');
    this.location.replaceState(url);
    this.cargando = true;
    this.firebaseAuth.getUser().subscribe(user => {
      this.userAuth = user;
      // this.estudianteService.getUser(user.uid).subscribe(tutor => {
      //   tutor.alumns.forEach(alumno => {
      //     alumno.get().then(snapchot => {
      //       this.cursosService.getCurso(snapchot.data().idLastCourse).subscribe(curso => {
      //         // console.log('10code log:', moment(curso.data()?.startDate?.seconds * 1000).format('DD/MM/YYYY'))
      //         console.log('10code log:', new Date(curso.data()?.startDate?.seconds * 1000))
      //       })
      //       //console.log('10code log:', snapchot.data())
      //     });
      //   });
      // });
      if (user?.uid) {
        this.firestore.collection('users').ref.where('idUserAuth', '==', user.uid).get()
          .then(querySnapshotUser => {
            if (!querySnapshotUser.empty) {
              let userRef = null;
              querySnapshotUser.forEach(userInfo => {
                userRef = userInfo.ref;
              });
              this.firestore.collection('users').ref.where('tutor', 'array-contains', userRef).get()
                .then(querySnapshot => {
                  if (!querySnapshot.empty) {
                    let flag = false;
                    querySnapshot.forEach(alumno => {
                      const alumnoData: any = alumno.data();
                      console.log('el alumno es ', alumnoData);
                      const studentMatriculado = this.checkMatriculadoTest(alumnoData);
                      if (studentMatriculado) {
                        flag = true;
                      }
                    });
                    if (flag) {
                      // this.cargando = false;
                      this.getUserInfo(userRef);
                    } else {
                      this.cargando = false;
                      console.log('el id del tutor es ', user?.uid);
                      this.router.navigate([`/infoacademica`]);
                      setTimeout(() => {
                        this.tutorService.changeIdTutor(user?.uid);
                      }, 500);
                    }
                  } else {
                    this.cargando = false;
                    console.log('el id del tutor es ', user?.uid);
                    this.router.navigate([`/infoacademica`]);
                    setTimeout(() => {
                      this.tutorService.changeIdTutor(user?.uid);
                    }, 500);
                  }
                  // location.reload();
                });
            } else {
              this.firebaseAuth.logout();
              this.cargando = false;
            }
          });
      }
    });
  }

  increaseIndex(): void {
    this.studentCurrent++;
  }

  decreaseIndex(): void {
    this.studentCurrent--;
  }

  getUserInfo(userRef: DocumentReference): void {
    userRef.get().then(userInfo => {
      this.user = userInfo.data();
      this.user.id = userInfo.id;
      console.log('el usuario es ', this.user);
      if (this.students.length === 0 && this.projects.length === 0) {
        this.cargando = false;
        this.findStudents();
      } else {
        this.cargando = false;
      }
    });
  }

  checkMatriculadoTest(alumnData: any): boolean {
    if (alumnData.status === 'registrado' ||  alumnData.status === 'Registrado') {
      return true;
      // || alumnData.status === 'test' || alumnData.status === 'cancelado' || alumnData.status === 'registrado'
      // || alumnData.status === 'finalizado'
    }
    /*return (alumnData.statusCourses) ?
    alumnData.statusCourses.filter(x => x.courseStatus === 'matriculado' || x.courseStatus === 'cancelado'
     || x.courseStatus === 'finalizado')
        .length > 0 : false;*/
  }

  async findStudents(): Promise<any> {
    if (this.user.alumns.length > 0) {
      this.user.alumns.forEach(async alumnRef => {
        const alumnInfo = await alumnRef.get();
        const alumnData = alumnInfo.data();
        const studentMatriculado = this.checkMatriculadoTest(alumnData);
        if (studentMatriculado) {
          const center = await alumnData.centro[0].get();
          alumnData.courseInfoArr = await Promise.all(alumnData.courses.map(async courseRef => {
            const courseRead = await courseRef.get();
            const courseData = courseRead.data();
            courseData.id = courseRead.id;
            return courseData;
          }));
          alumnData.courseInfoArr.forEach(async courseData => {
            const templateId: string = courseData.projectTemplate.split('/')[1];
            const projectTemplateRef = await this.firestore.collection('projects_templates').
            doc(templateId.trim()).ref.get();
            const projectTemplateData: any = (projectTemplateRef) ? projectTemplateRef.data() : undefined;
            const serie = await courseData.serie.get();
            const courseCenter = await courseData.center.get();
            courseData.centerDescr = courseCenter.data().description;
            alumnData.centroDescr = center.data().description;
            courseData.serieName = serie.data().name;
            alumnData.id = alumnRef.id;
            const fechaActual = new Date();
            const tematicMonth = (fechaActual.getMonth() === 6 || fechaActual.getMonth() === 7) ? 8 : fechaActual.getMonth();
            this.currentMonth = this.months[tematicMonth];
            const monthsToShow: any[] = (projectTemplateData) ?
             projectTemplateData.months.filter(month => month.monthName === this.currentMonth) :
             courseData.months.filter(month => month.monthName === this.currentMonth);

            // console.log('los meses a mostrar son ', this.currentMonth, ' ', monthsToShow, courseData);
            if (monthsToShow.length > 0) {
              courseData.projects = [];
              monthsToShow.forEach(async (month, index) => {
                const temathic = await month.temathic.get();
                month.temathic = temathic.data();
                const project = await month.project.get();
                month.project = project.data();
                const tipology = await month.tipology.get();
                month.tipology = tipology.data();
                courseData.projects.push(month);
                if (index === monthsToShow.length - 1) {
                  this.cargando = false;
                }
              });
            } else {
              this.cargando = false;
            }
            courseData.id = courseData.id;
          });
          this.students.push(alumnData);
        }
      });
      // console.log('los students son ', this.students);
    }
  }

  async modificar(title: string, boldTitle: string = null, formulario: Formulario, isAuthSave = false): Promise<any> {
    const formBuilt: any[] = formulario.createFormulario();
    // this.firebaseAuth.getUser().subscribe(us => console.log('el usuario es ', us));
    // for(let i = 0; i < formBuilt.length; i++) {
    for (const form of formBuilt) {
      if (form.element === 'select' && form.reference) {
        const collection = await this.firestore.collection(form.reference).get().toPromise();
        collection.forEach(value => {
          let valueRef = value.id;
          if (form.referenceValue !== 'id') {
            valueRef = value.data()[form.referenceValue];
          }
          form.options.push({ value: valueRef, key: value.data() });
        });
      }
    }
    const functionToSave = (formGroup: FormGroup, form: any[], ...params) => {
      // console.log('el authSave es', isAuthSave);
      const id = params[0][0];
      const formToSave = {};
      form.forEach(elem => {
        if (!elem.notSave) {
          if (elem.reference && elem.referenceValue === 'id') {
            const ref = this.firestore.collection(elem.reference).doc(formGroup.value[elem.name]).ref;
            formToSave[elem.name] = ref;
          } else if (formGroup.value[elem.name]) {
            formToSave[elem.name] = formGroup.value[elem.name];
          }
        }
      });
      if (!isAuthSave) {
        return this.firestore.collection('users').doc(id).update(formToSave);
      } else {
        return this.firestore.collection('users').doc(id).update(formToSave).then(x => {
          return this.userAuth.updateEmail(formGroup.value.email).then(email => {
            return this.userAuth.updatePassword(formGroup.value.password);
          }).catch(erro => erro);
        }).catch(erro => erro);
      }
    };
    console.log('el formulario después es ', formBuilt);
    this.messageService.showFormInDialog(formBuilt, title, boldTitle, functionToSave, 'my-custom-dialog-class', 'Guardado Correctamente',
      this.user.id).afterClosed()
      .subscribe(x => {
        if (x !== true) {
          this.messageService.openAlertDialog(x.message, 'Respuesta');
          this.getUserInfo(this.firestore.collection('users').doc(this.user.id).ref);
        }
      });
  }

  pintarBoletin(objetoEnviado: any): void {
    console.log('el objeto enviado es ', objetoEnviado);
    this.projectWinner = objetoEnviado.projectWinner;
    this.evaluationsToShow = objetoEnviado.evaluationsToShow;
    this.studentCurrent = objetoEnviado.studentCurrent;
    this.courseCurrent = objetoEnviado.courseCurrent;
    this.cargando = true;
    if (objetoEnviado.courseCurrent && this.evaluationsToShow['course_' + objetoEnviado.courseCurrent.id]
       .filter(eva => eva[objetoEnviado.dateRange]).length > 0) {
      this.addInfoBoletin(objetoEnviado.dateRange, objetoEnviado.courseCurrent);
      this.generarBoletin();
      // this.cargando = false;
    } else {

      this.messageService.openAlertDialog('El estudiante ' + this.students[this.studentCurrent].fullname +
        ' no tiene evaluaciones en este rango de fechas', 'Información');
      this.cargando = false;
    }
  }


  addInfoBoletin(dateRange: string, courseCurrent: any): void {
    const selectElementvalue = dateRange;
    // console.log(selectElementvalue);
    if (this.evaluationsToShow['course_' + courseCurrent.id] &&
     this.evaluationsToShow['course_' + courseCurrent.id].length > 0 && selectElementvalue) {

      this.periodEvaluation = selectElementvalue;
      const valueRead = this.evaluationsToShow['course_' + courseCurrent.id].filter(x => x[selectElementvalue])[0];
      if (valueRead[selectElementvalue]) {
        this.countriesData[0].value = valueRead[selectElementvalue].ejecucion;
        this.countriesData[1].value = valueRead[selectElementvalue].concentracion;
        this.countriesData[2].value = valueRead[selectElementvalue].iniciativa;
        this.countriesData[3].value = valueRead[selectElementvalue].docente;
        this.countriesData[4].value = valueRead[selectElementvalue].convivencia;
      } else {
        this.countriesData[0].value = 0;
        this.countriesData[1].value = 0;
        this.countriesData[2].value = 0;
        this.countriesData[3].value = 0;
        this.countriesData[4].value = 0;
      }
    } else {
      this.countriesData[0].value = 0;
      this.countriesData[1].value = 0;
      this.countriesData[2].value = 0;
      this.countriesData[3].value = 0;
      this.countriesData[4].value = 0;
    }
    // console.log('el formulario es ', this.formGeneral.value.studentEvaluation);
  }

  generarBoletin(): void {
    // GENERAR PDF CON ESTOS DATOS

    this.showPdf = false;
    this.cdRef.detectChanges();
    const element = document.getElementById('boletinpdf');
    setTimeout(x => {
      const opt = {
        margin: [0, 0, 0, 0], // top, left, buttom, right
        filename: `boletin.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: {
          //  scale: 2,
          //  bottom: 20
        },
        pagebreak: { mode: ['css'] },
        jsPDF: {
          unit: 'mm',
          orientation: 'portrait',
        },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .toPdf()
        .output('datauristring')
        .then((pdfAsString) => {
          this.ngZone.run(() => {
            this.showPdf = true;
            const pdfWindow = window.open('');
            pdfWindow.document.write(` <iframe src="${pdfAsString}" width="100%" height="100%">
            Tu navegador no socket_export_stream PDFs. Por favor, descargalo para poder verlo:
          </iframe>`);
            this.cargando = false;
          });
        }).catch(() => this.cargando = false);
    }, 2000);
  }

  procesarDocumento(data): void {
    console.log('la informacion es ', data);
    this.studentCurrent = data.currentStudent;
    this.courseCurrent = data.currentCourse;
    this.dataSent = data.value;
    const name = (data.name === 'contrato') ? `contrato_${this.courseCurrent.id}` :
      (data.name === 'recogidaMenores') ? `autRecogida_${this.courseCurrent.id}` : data.name;
    const docuPdf = (data.name === 'contrato' || data.name === 'recogidaMenores') ? name : this.documentsPDF[name];
    if (this.user.alumnosAut && this.user.alumnosAut[this.students[this.studentCurrent]?.id] &&
      this.user.alumnosAut[this.students[this.studentCurrent]?.id][docuPdf]) {
      this.cargando = true;
      this.angularStorage.storage.ref().child(this.user.alumnosAut[this.students[this.studentCurrent]?.id][docuPdf])
        .getDownloadURL()
        .then(url => {
          const pdfWindow = window.open('');
          pdfWindow.document.write(` <iframe src="${url}" width="100%" height="200%">
            Tu navegador no socket_export_stream PDFs. Por favor, descargalo para poder verlo:
          </iframe>`);
          this.cargando = false;
          console.log('la url es ', url);
        });

    } else {
      this.showFirma = false;
      this.htmlSignature = (!this.htmlSignature) ? document.getElementById('signature') : this.htmlSignature;
      this.messageService.showDocumentToSign(this.htmlSignature, 'firma', [], 'alert-documento', 'sig-image')
        .afterClosed()
        .toPromise()
        .then(signed => {
          if (signed.signImage) {
            if (data.name === 'contrato') {
              this.generarContrato(signed.signImage);
            } else {
              this.showFirma = true;
              switch (data.name) {
                case 'recogidaMenores':
                  this.objectShow.autRecogida = false;
                  this.htmlMenores = (!this.htmlMenores) ? document.getElementById('pdfAutMenores') : this.htmlMenores;
                  const pdfName3 = `${this.user.fullname}_${this.courseCurrent.description}_autorización_menores.pdf`;
                  this.verifyTypeDocument('autRecogida', this.htmlMenores, signed, pdfName3, 'pdfAutMenores', []);
                  break;
                case 'imagenes':
                  this.objectShow.autImagenes = false;
                  this.htmlImagenes = (!this.htmlImagenes) ? document.getElementById('pdfAutImagenes') : this.htmlImagenes;
                  const pdfName = `${this.user.fullname}_autorización_imagenes.pdf`;
                  this.verifyTypeDocument('autImagenes', this.htmlImagenes, signed, pdfName, 'pdfAutImagenes', ['checkbox1']);
                  break;
                case 'whatsapp':
                  this.objectShow.autWhatsapp = false;
                  this.htmlMWhatsapp = (!this.htmlMWhatsapp) ? document.getElementById('pdfAutWhatsapp') : this.htmlMWhatsapp;
                  const pdfName2 = `${this.user.fullname}_autorización_whatsapp.pdf`;
                  this.verifyTypeDocument('autWhatsapp', this.htmlMWhatsapp, signed, pdfName2, 'pdfAutImagenes', ['autorizo', 'informado', 'contacto']);
                  break;
              }
            }
          } else {
            this.messageService.openAlertDialog('No se ha guardado la firma', 'Error al guardar la firma');
          }
        });
    }
  }

  verifyTypeDocument(type: string, html: any, signed: any, pdfName: string, idElement: string, arrayFields: any[]): void {
    const imgWp = (html.getElementsByClassName('img-signed')[0]);
    imgWp.setAttribute('src', signed.signImage);
    this.messageService.showDocumentToSign(html, 'Formulario a firmar', arrayFields, 'alert-documento')
      .afterClosed()
      .subscribe(value => {
        console.log('el valor es ', value);
        if (value.html) {
          this.autorizacionDocumentos(idElement, pdfName, type, value.html);
        } else {
          this.messageService.openAlertDialog('El Documento sigue pendiente ya que no se han llenado los datos requeridos', 'Fallo en la firma');
        }
      });
  }

  async generarContrato(imageSigned: any): Promise<any> {

    // this.loadingService.startLoading();
    this.cargando = true;
    this.showPdfContrato = false;

    const element = document.getElementById('pdfContent');
    const contrato = (element.getElementsByClassName('img-signed')[0]);
    contrato.setAttribute('src', imageSigned);
    element.style.display = 'block';
    if (this.students.length > 0) {
      // const alumno = await this.data.getReferenceFromDoc(this.formGeneral.get('alumns').value[0]).get();
      // this.student = alumno.data();
      if (this.students[this.studentCurrent].courses && this.students[this.studentCurrent].courses.length > 0) {

        if (this.courseCurrent) {
          // this.course = courseRef.data();
          console.log('el curso es', this.courseCurrent);
          this.user.payment = 'Domiciliacion';
          const time = { 0: '00' };
          const startMin = (time[this.courseCurrent.startTime.minute]) ?
            time[this.courseCurrent.startTime.minute] : this.courseCurrent.startTime.minute;
          const endMin = (time[this.courseCurrent.endTime.minute]) ? time[this.courseCurrent.endTime.minute] :
            this.courseCurrent.endTime.minute;
          this.horarioSelected = this.courseCurrent.startTime.hour + ':' + startMin + ' a ' +
            this.courseCurrent.endTime.hour + ':' + endMin;

          this.day = (this.courseCurrent.weekDays[0] === 'Miercoles') ? 'Miércoles' : this.courseCurrent.weekDays[0];

          this.fullName = this.user.fullname;
          this.municipality = this.user.municipality;
          this.address = this.user.address + ' ' + this.user.number;
          this.dniDocument = this.user.document + ' ' + this.user.numberDNI;

          this.nombreCentro = this.courseCurrent.centerDescr;
          const month = this.currentDate.getMonth();
          if (month) {
            this.mesInscripcion = this.arrMeses[month];
          }
          if (month === 5) {
            this.meses = 1;
          } else if (month >= 8 && month <= 11) {
            this.meses = 9 - (month - 8);
          } else if (month >= 0 && month <= 4) {
            this.meses = 5 - month;
          }
          const namePdf = `${this.user.fullname}_${this.courseCurrent.description}_contrato.pdf`;
          const opt = {
            margin: [12.5, 0, 12, 0], // top, left, buttom, right
            filename: namePdf,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
              //  scale: 2,
              //  bottom: 20
            },
            pagebreak: { mode: ['css'] },
            jsPDF: {
              unit: 'mm',
              orientation: 'portrait',
            },
          };

          html2pdf()
            .set(opt)
            .from(element)
            .toPdf()
            .output('datauristring')
            .then((pdfAsString) => {
              this.ngZone.run(() => {
                // element.style.display = 'none';
                // this.cargando = false;
                this.showPdfContrato = true;
                const pdfWindow = window.open('');
                pdfWindow.document.write(` <iframe src="${pdfAsString}" width="100%" height="200%">
                  Tu navegador no socket_export_stream PDFs. Por favor, descargalo para poder verlo:
                </iframe>`);
                console.log('el id del usuario al momento de generar documento es ', this.user.id);
                this.angularStorage.storage
                  .ref()
                  .child(`tutors/documents/authorizations/${this.user.id}/alumnos/${this.students[this.studentCurrent].id}/${namePdf}`)
                  .putString(pdfAsString, 'data_url', { contentType: 'application/pdf' })
                  .then(load => {
                    console.log('se subió el archivo', load);
                    const loadPath = load.ref.fullPath;
                    const field = `contrato_${this.courseCurrent.id}`;
                    const objectToModify = { alumnosAut: { [this.students[this.studentCurrent].id]: { contrato: '' } } };
                    if (this.user.alumnosAut && this.user.alumnosAut[this.students[this.studentCurrent]?.id]) {
                      objectToModify.alumnosAut[this.students[this.studentCurrent]?.id] = this.user.
                        alumnosAut[this.students[this.studentCurrent]?.id];
                    }
                    objectToModify.alumnosAut[this.students[this.studentCurrent]?.id][field] = loadPath;
                    delete objectToModify.alumnosAut[this.students[this.studentCurrent]?.id].contrato;
                    this.firestore.collection('users').doc(this.user.id).ref
                      .update(objectToModify)
                      .then(response => {
                        this.cargando = false;
                        this.messageService.openAlertDialog('Se ha firmado el documento correctamente', 'Firma exitosa');
                        if (!this.user.alumnosAut) {
                          this.user.alumnosAut = objectToModify.alumnosAut;
                        }
                      })
                      .catch(error => {
                        this.cargando = false;
                        this.messageService.openAlertDialog('Hubo un problema guardando la firma ' + error, 'Error en la firma');
                        this.angularStorage.storage.ref().child(loadPath).delete();
                      });
                  })
                  .catch(error => {
                    this.cargando = false;
                    this.messageService.openAlertDialog('Hubo un problema guardando la firma ' + error, 'Error en la firma');
                  });
              });
            });
        } else {
          this.messageService.openAlertDialog('Este alumno no tiene cursos asociados', 'error');
          this.cargando = false;
          this.showPdfContrato = true;
        }
      } else {
        this.messageService.openAlertDialog('Este alumno no tiene cursos asociados', 'error');
        this.cargando = false;
        this.showPdfContrato = true;
      }
    }
  }

  async autorizacionDocumentos(id?: string, namePdf?: string, nameShow?: string, el?: HTMLElement): Promise<any> {

    this.cargando = true;
    const element = el; // document.getElementById(id);
    // element.style.display = 'block';

    if (this.students.length > 0) {
      if (this.students[this.studentCurrent].courses && this.students[this.studentCurrent].courses.length > 0) {
        if (this.courseCurrent) {
          const opt = {
            margin: [12.5, 0, 12, 0], // top, left, buttom, right
            filename: namePdf,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
              //  scale: 2,
              //  bottom: 20
            },
            pagebreak: { mode: ['css'] },
            jsPDF: {
              unit: 'mm',
              orientation: 'portrait',
            },
          };

          html2pdf()
            .set(opt)
            .from(element)
            .toPdf()
            .output('datauristring')
            .then((pdfAsString: string) => {
              this.ngZone.run(() => {
                // element.style.display = 'none';
                // this.cargando = false;
                this.objectShow[nameShow] = true;
                const pdfWindow = window.open('');
                pdfWindow.document.write(` <iframe src="${pdfAsString}" width="100%" height="200%">
                  Tu navegador no socket_export_stream PDFs. Por favor, descargalo para poder verlo:
                </iframe>`);
                console.log('el id del usuario al momento de generar documento es ', this.user.id);
                this.angularStorage.storage
                  .ref()
                  .child(`tutors/documents/authorizations/${this.user.id}/alumnos/${this.students[this.studentCurrent].id}/${namePdf}`)
                  .putString(pdfAsString, 'data_url', { contentType: 'application/pdf' })
                  .then(load => {
                    console.log('se subió el archivo', load);
                    const loadPath = load.ref.fullPath;
                    const objectToModify = (nameShow !== 'autRecogida') ? { alumnosAut: { [this.students[this.studentCurrent].id]: {} },
                     documentAuth: {[this.students[this.studentCurrent].id]: {} }} :
                     { alumnosAut: { [this.students[this.studentCurrent].id]: {} }, documentAuth:
                      {[this.students[this.studentCurrent].id]: {} }, infoRecogida:
                      {[this.students[this.studentCurrent].id]: this.dataSent }} ;
                    if (this.user.alumnosAut && this.user.alumnosAut[this.students[this.studentCurrent]?.id]) {
                      objectToModify.alumnosAut[this.students[this.studentCurrent]?.id] = this.user.
                        alumnosAut[this.students[this.studentCurrent]?.id];
                    }
                    if (this.user.documentAuth && this.user.documentAuth[this.students[this.studentCurrent]?.id]) {
                      objectToModify.documentAuth[this.students[this.studentCurrent]?.id] = this.user.
                      documentAuth[this.students[this.studentCurrent]?.id];
                    }
                    const field = (nameShow === 'autRecogida') ? `autRecogida_${this.courseCurrent.id}` : nameShow;
                    objectToModify.alumnosAut[this.students[this.studentCurrent]?.id][field] = loadPath;
                    objectToModify.documentAuth[this.students[this.studentCurrent]?.id] = this.documentAuth;
                    this.firestore.collection('users').doc(this.user.id).ref
                      .update(objectToModify)
                      .then(response => {
                        this.cargando = false;
                        this.messageService.openAlertDialog('Se ha firmado el documento correctamente', 'Firma exitosa');
                        if (!this.user.alumnosAut) {
                          this.user.alumnosAut = objectToModify.alumnosAut;
                        }
                      })
                      .catch(error => {
                        this.messageService.openAlertDialog('Hubo un problema guardando la firma ' + error, 'Error en la firma');
                        this.angularStorage.storage.ref().child(loadPath).delete();
                      });
                  })
                  .catch(error => {
                    this.messageService.openAlertDialog('Hubo un problema guardando la firma ' + error, 'Error en la firma');
                  });
              });
            });
        } else {
          this.messageService.openAlertDialog('Este alumno no tiene cursos asociados', 'error');
          this.cargando = false;
          this.objectShow[nameShow] = true;
        }
      } else {
        this.messageService.openAlertDialog('Este alumno no tiene cursos asociados', 'error');
        this.cargando = false;
        this.objectShow[nameShow] = true;
      }
    }
  }

  checkoutBilling(valueEmitted: any): void {
    if (valueEmitted.cargando) {
      this.cargando = true;
    } else {
      this.cargando = false;
      this.students[this.studentCurrent].receipts = valueEmitted.receipts;
    }
    console.log('los estudiantes en profile son ', this.students);
    this.cdRef.detectChanges();
  }
  async getIdReceiptImprimir(receipt: any): Promise<any> {
    this.recibo = receipt;
    this.cdRef.detectChanges();
    console.log('el recibo es', this.recibo);
    if (this.recibo) {
      // let tutorReference = recibo[`tutor`];
      // tutorReference = tutorReference.replace('users/', '');
      const tutor = this.user; // await this.dataUsers.get({ id: tutorReference });
      // let studentReference = recibo[`student`];
      // studentReference = studentReference.replace('users/', '');
      const student = this.students[this.studentCurrent]; // await this.dataUsers.get({ id: studentReference });
      // info tutor
      if (tutor) {
        this.recibo.tutor = {};
        this.recibo.tutor.nombre = tutor[`fullname`];
        this.recibo.tutor.document = tutor[`document`];
        this.recibo.tutor.numberDNI = tutor[`numberDNI`];
        this.recibo.tutor.number = tutor[`number`];
        if (tutor[`address`].includes(tutor[`tipoVia`])) {
          this.recibo.tutor.address = tutor[`address`];
        } else {
          this.recibo.tutor.address = `${tutor[`tipoVia`]} ${tutor[`address`]}`;
        }
        this.recibo.tutor.zip = tutor[`zip`];
        this.recibo.tutor.municipality = tutor[`municipality`];
        this.recibo.tutor.cityTitular = tutor[`cityTitular`];
        this.recibo.tutor.email = tutor[`email`];
        const metodoPago = await this.recibo[`paymentMethod`].get();
        // this.metodosPago.find(metodo => metodo[`id`] === this.recibo[`paymentMethod`]);
        console.log('el metodo de pago es ', metodoPago.data());
        if (metodoPago && metodoPago.data()) {
          this.recibo.tutor.paymentMethod = metodoPago.data().paymentMethod;
          if (metodoPago.data().paymentMethod === 'Domiciliación') {
            this.recibo.tutor.IBAN = tutor[`IBAN`];
          } else if (metodoPago.paymentMethod === 'Transferencia') {
            this.recibo.tutor.IBAN = `ES22 0049 4510 35 2310014880`;
          }
        }
        // estudiante
      }
      if (student) {
        this.recibo.student = {};
        this.recibo.student.nombre = student[`fullname`];
        const cursos = this.recibo[`idCourse`];
        if (cursos && cursos.length > 0) {
          cursos.forEach(cur => {
            const cursoArr: any[] = student.courseInfoArr; // this.courses.find(course => course[`id`] === cur);
            if (cursoArr && cursoArr.length > 0) {
              const curso = cursoArr.filter(curs => curs.id === this.recibo.courseCurrent.id)[0];
              this.recibo.student.codeCourse = this.recibo.student.codeCourse ? `${this.recibo.student.codeCourse} , ${curso[`code`]}`
                : curso[`code`];
              this.recibo.student.course = this.recibo.student.course ? `${this.recibo.student.course} , ${curso[`description`]}`
                : curso[`description`];
            }
            const centro = student.centroDescr; // this.centros.find(cen => cen[`id`] === `centers/${curso[`center`][`id`]}`);
            if (centro) {
              this.recibo.student.center = centro;
            }
          });
        }
      }
      const conceptos = this.recibo[`billableConcepts`];
      if (conceptos && conceptos.length > 0) {
        this.recibo.conceptos = [];
        conceptos.forEach(con => {
          if (con) {
            this.recibo.iva = this.recibo.iva && this.recibo.iva > con[`iva`] ? this.recibo.iva : con[`iva`];
            if (this.recibo.conceptos && this.recibo.conceptos.length > 0) {
              const tabla: any = {};
              tabla.description = con[`billableConceptsDescription`];
              tabla.precioUnitario = con[`amount`];
              tabla.iva = con[`iva`];
              tabla.descuento = con[`discount`];
              tabla.precio = con[`netPayment`];
              this.recibo.conceptos.push(tabla);
            } else {
              const tabla: any = {};
              tabla.description = con[`billableConceptsDescription`];
              tabla.precioUnitario = con[`amount`];
              tabla.iva = con[`iva`];
              tabla.descuento = con[`discount`];
              tabla.precio = con[`netPayment`];
              this.recibo.conceptos = [tabla];
            }
          }
        });
      }
      this.recibo.conceptos = this.recibo.conceptos.sort((a, b) => b.precio < a.precio ? -1 : b.precio < a.precio ? +1 : 0);
      const fecha: any = this.timeConverterList(this.recibo[`emissionDate`]);
      this.recibo.emissionDate = `${fecha}`;
      this.recibo.numberReceipts = this.recibo[`numberReceipts`];
      this.recibo.total = this.recibo[`total`];
      this.recibo.impuestos = this.recibo.total * this.recibo.iva;
      this.recibo.totalParcial = this.recibo.total - this.recibo.impuestos;
      const state = this.recibo[`state`];
      this.recibo.estado = state ? state.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
      // this.dataSourcePDF = this.recibo.conceptos;
      this.cargando = true;
      this.showPdf = false;

      const element = document.getElementById('pdfRecibo');

      element.style.display = 'block';


      const opt = {
        filename: `recibo.pdf`,
        image: { type: 'jpeg' },
        html2canvas: {
          //  scale: 2,
          //  bottom: 20
        },
        pagebreak: { mode: ['css'] },
        jsPDF: {
          orientation: 'portrait',
        },
      };

      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .output('datauristring')
        .then((pdfAsString) => {
          this.ngZone.run(() => {
            this.showPdf = true;
            this.cargando = false;
            const pdfWindow = window.open('');
            pdfWindow.document.write(` <iframe src="${pdfAsString}" width="100%" height="100%">
            Tu navegador no socket_export_stream PDFs. Por favor, descargalo para poder verlo:
          </iframe>`);
          });
        });
    }
  }

  checkBoxDocumentos(check: any, valueToSave: boolean, tipoDoc: string, auth: string): void {
    if (check) {
      check.checked = false;
    }
    if (this.documentAuth) {
      if (this.documentAuth[tipoDoc]) {
        this.documentAuth[tipoDoc][auth] = valueToSave;
      } else {
        this.documentAuth[tipoDoc] =  {[auth]: valueToSave};
      }
    } else {
      this.documentAuth = (this.students[this.studentCurrent].documentAuth) ? this.students[this.studentCurrent].documentAuth : {};
      this.documentAuth[tipoDoc] =  {[auth]: valueToSave};
    }
    console.log(this.documentAuth);
  }


  timeConverterList(timestamp): number {
    let time: any;
    if (timestamp.seconds) {
      const a = new Date(timestamp.seconds * 1000);
      const year = a.getFullYear();
      const month = a.getMonth() + 1;
      const date = a.getDate();
      const hour = a.getHours();
      const min = a.getMinutes();
      const sec = a.getSeconds();
      time = date + '/' + month + '/' + year;
    } else {
      if (timestamp.year && timestamp.month && timestamp.day) {
        time = timestamp.day + '/' + timestamp.month + '/' + timestamp.year;
      }
    }
    // const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    return time;
  }

  dateFormat(date: any): string {
    let returnDate = new Date();
    if (date && date.year && date.month) {
      returnDate = new Date(date.year, date.month - 1, date.day);
    } else if (date instanceof Date) {
      returnDate = date;
    } else if (date.seconds) {
      returnDate = new Date(date.seconds * 1000);
    }
    const objDate = { 0: '00', 1: '01', 2: '02', 3: '03', 4: '04', 5: '05', 6: '06', 7: '07', 8: '08', 9: '09' };
    const objMonth = {
      0: '01', 1: '02', 2: '03', 3: '04', 4: '05', 5: '06', 6: '07', 7: '08', 8: '09', 9: '10',
      10: '11', 11: '12'
    };
    const month = (objMonth[returnDate.getMonth()]) ? objMonth[returnDate.getMonth()] : returnDate.getMonth();
    const dateRe = (objDate[returnDate.getDate()]) ? objDate[returnDate.getDate()] : returnDate.getDate();
    return dateRe + '-' + month + '-' + returnDate.getFullYear();
  }

  menuItemShown(menu: string): void {
    this.menuItemChoosen = menu;
  }

  logout(): void {
    this.firebaseAuth.logout();
  }
}
